import { render, staticRenderFns } from "./PackageTypePurchaseRecordModal.vue?vue&type=template&id=7fbae6c8"
import script from "./PackageTypePurchaseRecordModal.vue?vue&type=script&lang=js"
export * from "./PackageTypePurchaseRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports